<template>
  <div class="cartouche grid">
    <div class="cartouche__row1 grid">
      <div class="cartouche__row1--col1">© 2021 DuPont</div>
<!--      <div class="cartouche__row1&#45;&#45;col2"></div>-->
<!--      <div class="cartouche__row1&#45;&#45;col3"></div>-->
<!--      <div class="cartouche__row1&#45;&#45;col4"></div>-->
<!--      <div class="cartouche__row1&#45;&#45;col5"></div>-->
    </div>
    <div class="cartouche__row2--col1">{{ code }} - {{ region }} - EN</div>
    <div class="cartouche__row2--col2">{{ title }}</div>
    <div class="cartouche__row2--col3">DuPont<sup>™</sup> Corian<sup>®</sup> Solid Surface</div>
    <div class="cartouche__row3--col1">DISCLAIMER: E.I du Pont de Nemours and Company , hereinafter referred to as “DuPont ”shall not be liable for any direct and/or indirect damage suffered by the buyer or his customers and/or users as a consequence of disregarding or incorrectly using the instructions, standards and admission requirements for storage, manipulation or processing, use or implementation. Neither shall “DuPont”be liable in case the buyer or his customers and/or users do not comply with the applicable government regulations or in the event that the delivered goods are applied in violation with the applicable government regulations. The advice and recommendations by “DuPont”have an advisory nature only and shall be provided by the seller, to the best of its ability and understanding in conformity with the requirements of good workmanship. The advice and recommendations given do not contain any guarantees. In no way is the buyer or his customers and/or users released from any obligation to investigate the soundness of any advice and recommendations for the intended application. Advice and recommendations by DuPont only relate to DuPont products, except when DuPont states otherwise, explicitly and in writing.
    </div>

  </div>
</template>

<script>
export default {
  name: "cartouche",
  created() {
    let obj = this.$appData.find(data => data.code === this.code);
    // if(obj) this.title = obj.title;
  },

  computed: {
    region() {
      return 'EMEA'
      //return (this.type === 'concrete') ? 'EMEA' : 'NA'
    }
  },
  props: {
    code: {type: String},
    type: {type: String},
    title: {type: String},
  }
}
</script>

<style lang="scss">
.cartouche.grid {
  width: 90%;
  margin: 0 auto;
  grid-template-rows: auto;
  grid-template-columns:repeat(5, auto);
  align-items: center;
  color: rgba(black, .7);
  grid-template-areas:
        "cartouche__row1 cartouche__row1 cartouche__row1 cartouche__row1 cartouche__row1"
        "cartouche__row2--col1 cartouche__row2--col2 cartouche__row2--col2 cartouche__row2--col3 cartouche__row2--col3"
        "cartouche__row3--col1 cartouche__row3--col1 cartouche__row3--col1 cartouche__row3--col1 cartouche__row3--col1";
}
div[class*=cartouche__row]:not(.grid) {
  outline: 1px solid gainsboro;
  padding: .5rem
}
.cartouche__row1 {
  grid-area: cartouche__row1;
  grid-template-columns:1fr repeat(4, auto);
  align-items: center;
  grid-template-areas:
            "cartouche__row1--col1 cartouche__row1--col2 cartouche__row1--col3 cartouche__row1--col4 cartouche__row1--col5"
}
.cartouche__row1--col1 {
  grid-area: cartouche__row1--col1
}
.cartouche__row1--col2 {
  grid-area: cartouche__row1--col2
}
.cartouche__row1--col3 {
  grid-area: cartouche__row1--col3
}
.cartouche__row1--col4 {
  grid-area: cartouche__row1--col4
}
.cartouche__row1--col5 {
  grid-area: cartouche__row1--col5
}
.cartouche__row2--col1 {
  grid-area: cartouche__row2--col1
}
.cartouche__row2--col2 {
  grid-area: cartouche__row2--col2
}
.cartouche__row2--col3 {
  grid-area: cartouche__row2--col3
}
.cartouche__row3--col1 {
  grid-area: cartouche__row3--col1
}
</style>